import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CascadingFiltersList } from '../CascadingFiltersList/CascadingFiltersList';
import { CascadingFiltersHeader } from '../CascadingFiltersHeader/CascadingFiltersHeader';

export const CascadingFiltersSection = ({
  headerName,
  options,
  setCascadingFilters,
  cascadingFilters,
  setOpenSection,
  openSection,
  setCascadingFiltersLocal,
  cascadingFiltersLocal,
  cascadingFiltersConfig,
  isCascadingFilterOff,
  getChipLabel,
  businessSalesMonthData,
}) => {
  const [error, setError] = useState();
  return (
    <CascadingFiltersHeader
      headerName={headerName}
      options={options}
      setCascadingFilters={setCascadingFilters}
      cascadingFilters={cascadingFilters}
      setOpenSection={setOpenSection}
      openSection={openSection}
      setCascadingFiltersLocal={setCascadingFiltersLocal}
      cascadingFiltersLocal={cascadingFiltersLocal}
      getChipLabel={getChipLabel}
      error={error}
    >
      <CascadingFiltersList
        headerName={headerName}
        options={options}
        setCascadingFilters={setCascadingFilters}
        cascadingFilters={cascadingFilters}
        setCascadingFiltersLocal={setCascadingFiltersLocal}
        cascadingFiltersLocal={cascadingFiltersLocal}
        cascadingFiltersConfig={cascadingFiltersConfig}
        isCascadingFilterOff={isCascadingFilterOff}
        businessSalesMonthData={businessSalesMonthData}
        error={error}
        setError={setError}
      />
    </CascadingFiltersHeader>
  );
};

CascadingFiltersSection.propTypes = {
  headerName: PropTypes.string,
  options: PropTypes.array,
  setCascadingFilters: PropTypes.func,
  cascadingFilters: PropTypes.array,
  setOpenSection: PropTypes.func,
  openSection: PropTypes.string,
  setCascadingFiltersLocal: PropTypes.func,
  cascadingFiltersLocal: PropTypes.array,
  cascadingFiltersConfig: PropTypes.array,
  isCascadingFilterOff: PropTypes.bool,
  getChipLabel: PropTypes.func,
  businessSalesMonthData: PropTypes.object,
};
